<template>
  <footer>
    <div>      
      <div>
        <h2 v-if="$store.state.repId == '23'">SI NO ENCUENTRA UN TIEMPO QUE LE CONVENGA, FAVOR DE ENVIAR CORREO A BOLETOS@SANDIEGOFC.COM, Y HAREMOS LO MEJOR PARA ACOMODARNOS A SU TIEMPO PREFERIDO.</h2>
        <h2 v-else>If you do not see a timeslot available that works for you, please email us at interest@sandiegofc.com, and we will do our best to accommodate your preferred time.</h2>
        <div class='schedule'>          
        </div>
      </div>
    </div>
  </footer>
</template>


<style lang="scss" scoped>
.schedule {
  text-transform: uppercase;  
  p {
    color:var(--dark-blue);    
  }
}
footer {
  font-size: 1rem;  
  text-align: center;
  color: var(--dark-blue);
  background:var(--white);
  padding: 83px;
  box-sizing: border-box;
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1000px;
    margin: 0 auto;
    flex-direction: column;
    gap: 20px;            
    @media (min-width:400px) {
      flex-direction: row;      
      justify-content: center;
      max-width: 570px;
      margin:0 auto;
      gap:65px;
    }
  }  
  h2 {
    font-size: 1rem;
    margin: 0;
    text-transform: uppercase;    
    font-family: "Modern Era";
  }
  p {
    margin: 0;
    color:var(--white);
  }
}
a {
  text-decoration: none;
  color:inherit;
}
</style>